export let changes = 0;

export function setChanges(num) {
    changes = num;
}